module.exports = __webpack_public_path__ + "static/img/xk1.83e046f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/xk1.png
// module id = FKmG
// module chunks = 0